import { render, staticRenderFns } from "./selectyear.vue?vue&type=template&id=3a34c15d&"
import script from "./selectyear.js?vue&type=script&lang=js&"
export * from "./selectyear.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a34c15d')) {
      api.createRecord('3a34c15d', component.options)
    } else {
      api.reload('3a34c15d', component.options)
    }
    module.hot.accept("./selectyear.vue?vue&type=template&id=3a34c15d&", function () {
      api.rerender('3a34c15d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/inputs/selectyear.vue"
export default component.exports